import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { SharedModule } from '@shared/module/shared.module';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BaseComponent } from '@shared/components/base/base.component';
import { LikesService } from '@shared/service/http_services/like.service';
import { CreateLikeModel } from '@shared/model/customerModels/like-model';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { FooterItemPipe } from '@shared/components/Activities/pipes/footer-item.pipe';
import { BooklistItemComponent } from './components/booklist-item/booklist-item.component';
import { BooklistAggrigatorModel } from '@app/pages/booklists/models/booklist-aggrigator-model';
import { HeaderComponent, HeaderConfigModel } from '@shared/components/header/header.component';
import { BooklistAggrigatorService } from '@app/pages/booklists/services/booklist-aggrigator.service';
import { GetUserDataPipe } from '@shared/components/User-Activity-Info/pipes/get-user-data/get-user-data.pipe';
import { ActivityLikedUsersComponent } from '@shared/components/activity-liked-users/activity-liked-users.component';
import { UserActivityInfoComponent } from '@shared/components/User-Activity-Info/user-activity-info/user-activity-info.component';
import { ActivityFooterPluseComponent } from '@shared/components/Activities/activity-footer-pluse/activity-footer-plus.component';
import { LocalRepository } from '@shared/helper/local-repository';
import { BookmarkHandlerService, CreateBookmarkModel } from '@shared/service/http_services/handler/bookmark-handler.service';

@Component({
  selector: 'app-booklists',
  imports: [
    SharedModule,
    FooterItemPipe,
    HeaderComponent,
    GetUserDataPipe,
    InfiniteScrollDirective,
    BooklistItemComponent,
    UserActivityInfoComponent,
    ActivityFooterPluseComponent,
  ],
  templateUrl: './booklists.component.html',
  styleUrls: ['./booklists.component.scss']
})
export class BooklistsComponent extends BaseComponent implements OnInit {
  private _dialog = inject(MatDialog);
  private titleService = inject(Title);
  private likesService = inject(LikesService);
  private _bottomSheet = inject(MatBottomSheet);
  private activatedRoute = inject(ActivatedRoute);
  private _localRepository = inject(LocalRepository);
  private bookmarkHandlerService = inject(BookmarkHandlerService);
  private bookListAggrigatorService = inject(BooklistAggrigatorService);

  headerConfig: HeaderConfigModel = {
    title: 'لیست‌های کتاب'
  }

  termfilter: TermFilterModel = new TermFilterModel(0, 20)
  booklists: BooklistAggrigatorModel[] = [];
  hasMore!: boolean;
  loading = true;
  itemId: any;
  loadingMore!: boolean;
  bookBooklists = false;

  constructor() {
    super();

  }

  ngOnInit(): void {
    const query = this.activatedRoute.snapshot.queryParams;

    if (query['id']) {
      this.itemId = query['id'];

      if (query?.['T'] === 'book') {
        this.bookBooklists = true;
        this.bookListAggrigatorService.getBooklistsOfBook(this.itemId, this.termfilter)
          .subscribe(res => {
            this.bookBooklists = false;
            if (res.hasError) return;
            this.booklists = res.result?.items;
            this.handleLocalVariables(res.result?.hasNextPage);
            this.titleService.setTitle('بهخوان | لیست‌های کتاب');
          });
      }
      else if (query?.['T'] === 'user') {
        this.bookListAggrigatorService.getGuestBookLists(this.itemId, this.termfilter)
          .subscribe(res => {
            if (res.hasError) return;
            this.booklists = res.result?.items;
            this.handleLocalVariables(res.result?.hasNextPage);
            this.titleService.setTitle('بهخوان | لیست‌های کتاب');
          });
      }
    }
    else {
      this.bookListAggrigatorService.getChosenBookListsWithUserLiked(this.termfilter)
        .pipe(
          takeUntil(this.unsubscribe$)
        ).subscribe(res => {
          if (res.hasError) return;
          this.booklists = res.result?.items;
          this.handleLocalVariables(res.result?.hasNextPage);
        });
    }
  }

  openUsersDialog(postId: string) {
    this.utilFunctions.peopleLiked(postId, this._bottomSheet, this._dialog, this._localRepository, ActivityLikedUsersComponent);
  }

  likeItem(likedObject: CreateLikeModel) {
    if (!this.currentUser?.uniqeName && !this.currentUser?.firstName) {
      this.utilFunctions.opensigninDialog(this._dialog, '/', this._localRepository);
      return
    }
    this.likesService.createLike(likedObject, this.currentUser?.id!).subscribe();
  }

  loadMore() {
    if (this.hasMore) {
      this.loadingMore = true;
      this.termfilter.pgNumber++;
      if (this.itemId) {
        if (this.bookBooklists) {
          this.bookListAggrigatorService.getBooklistsOfBook(this.itemId, this.termfilter)
            .subscribe(res => {
              if (res.hasError) return;
              this.pushDataToArray(res.result?.items);
              this.handleLocalVariables(res.result?.hasNextPage);
            });
        }
        else {
          this.bookListAggrigatorService.getGuestBookLists(this.itemId, this.termfilter)
            .subscribe(res => {
              if (res.hasError) return;
              this.pushDataToArray(res.result?.items);
              this.handleLocalVariables(res.result?.hasNextPage);
            });
        }
      }
      else {
        this.bookListAggrigatorService.getAllBookLists(this.termfilter)
          .pipe(
            takeUntil(this.unsubscribe$)
          ).subscribe(res => {
            if (res.hasError) return;
            this.pushDataToArray(res.result?.items);
            this.handleLocalVariables(res.result?.hasNextPage);
          });
      }
    }
  }

  pushDataToArray(items: BooklistAggrigatorModel[]) {
    items.forEach(item => {
      this.booklists.push(item);
    })
  }

  handleLocalVariables(nextPage: boolean) {
    this.hasMore = nextPage;
    this.loading = false;
    this.loadingMore = false;
  }

  bookmarkItem(bookmarkData: CreateBookmarkModel,) {
    this.bookmarkHandlerService.handleBookmark(bookmarkData)
      .subscribe(res => {
        if (bookmarkData.userMarked) {
          res.hasError ? bookmarkData.object.userMarked = true : null;
        }
        else {
          res.hasError ? bookmarkData.object.userMarked = false : null;
        }
      });
  }

}
